import React from 'react'
import { Payments } from 'src/components/payment/Payments'

export const PaymentsPage = () => {
  return (
    <div data-testid="dashboard-payments-page">
      <Payments />
    </div>
  )
}
